import { useEffect, useState } from "react";

import {ReactComponent as DeleteIcon} from "../../icons/Delete24.svg";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import NumericInput from "react-numeric-input";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import {
  StripedTableRow,
  StripedTableCell,
} from "../StripedTable";
import { getCommServiceTypes } from "../../services/CommServiceService";
import SubTitle from "../SubTitle";
import TableRowNoResults from "../TableRowNoResults";
import { TableHead } from "@mui/material";

const CommServiceBulkDialog = ({
  school,
  jwt,
  dialogOpen,
  setDialogOpen,
  dialogClose,
  doUpdateSelectedItem,
  onSave,
  students = [],
  commServiceType,
  setCommServiceType,
  commServiceDescription,
  setCommServiceDescription,
  existingOps = [],
  onClickRemove
}) => {
  const [_csLoading, setCsLoading] = useState(false);
  const [_commServiceTypes, setCommServiceTypes] = useState([]);
  const [_selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    initTypes();
  }, []);

  const initTypes = () => {
    setCsLoading(true);
    getCommServiceTypes(school, jwt).then((results) => {
      setCsLoading(false);
      setCommServiceTypes(results.data);
    });
  };

  const handleClose = () => {
    setDialogOpen(false);
    if (dialogClose) {
      dialogClose();
    }
  };

  const handleChangeType = (event) => {
    const eid = event.target.value;
    setCommServiceType(eid);
  };

  const onTabChange = (event, index) => setSelectedTabIndex(index);

  return (
    <Dialog onClose={handleClose} open={dialogOpen} fullWidth={true} fullScreen>
      <DialogTitle>Manage Service Ops</DialogTitle>

      <DialogContent>
        <Alert severity="info">
          To create new Service Ops for students, click the "New Entries tab
          below, then enter the Ops details for each student in this event."
          <br />
          Click "Existing Entries" below to see the previous service ops created
          for this activity.
        </Alert>

        <Box sx={{ bgcolor: "#e0e0e0", mt: 1 }} fullWidth>
          <Tabs value={_selectedTabIndex} onChange={onTabChange}>
            <Tab label="New Entries" style={{ color: "black" }} />
            <Tab label="Existing Entries" style={{ color: "black" }} />
          </Tabs>
        </Box>

        {_selectedTabIndex === 0 && (
          <Box sx={{ boxShadow: 1, p: 1, mt: 1 }}>
            <SubTitle text="New Entries" />

            <InputLabel sx={{ mt: 1 }}>* Service Type:</InputLabel>
            <Select
              onChange={handleChangeType}
              value={commServiceType}
              fullWidth
              size="small"
            >
              <MenuItem value="XX">-- SELECT --</MenuItem>
              {_commServiceTypes.map((type) => (
                <MenuItem key={type.eid} value={type.eid}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>

            <InputLabel sx={{ mt: 1 }}>* Description</InputLabel>
            <TextField
              margin="dense"
              type="text"
              fullWidth
              size="small"
              onChange={(evt) => setCommServiceDescription(evt.target.value)}
              placeholder="Required Field"
              value={commServiceDescription}
              sx={{ mt: 0 }}
            />

            <TableContainer component={Paper} sx={{ mt: 1 }}>
              <Table sx={{ width: "100%" }} size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Student</StripedTableCell>
                    <StripedTableCell>Hours</StripedTableCell>
                    <StripedTableCell>Minutes</StripedTableCell>
                  </StripedTableRow>
                </TableHead>
                <TableBody>
                  <TableRowNoResults data={students} />
                  {students.map((student) => (
                    <StripedTableRow key={student.user_eid}>
                      <StripedTableCell>
                        {student.last_name}, {student.first_name}
                      </StripedTableCell>
                      <StripedTableCell>
                        <NumericInput
                          className="numericInput"
                          min={0}
                          max={8}
                          value={student.hourNum}
                          onChange={(value) => {
                            doUpdateSelectedItem(
                              student,
                              value,
                              student.minuteNum
                            );
                          }}
                        />
                      </StripedTableCell>
                      <StripedTableCell>
                        <NumericInput
                          className="numericInput"
                          min={0}
                          max={45}
                          step={15}
                          value={student.minuteNum}
                          onChange={(value) => {
                            doUpdateSelectedItem(
                              student,
                              student.hourNum,
                              value
                            );
                          }}
                        />
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>

                {/* <TableBody>
              <StripedTableRow>
                <StripedTableHeadCell>Student</StripedTableHeadCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Service Date</StripedTableHeadCell>
                <StripedTableCell>
                  {dayjs(selectedItem.eventDate).format("MM/DD/YY")}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Created</StripedTableHeadCell>
                <StripedTableCell>
                  {dayjs(selectedItem.dateCreated).format("MM/DD/YY")}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Type</StripedTableHeadCell>
                <StripedTableCell>{selectedItem.typeName}</StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Description</StripedTableHeadCell>
                <StripedTableCell>{selectedItem.description}</StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Status</StripedTableHeadCell>
                <StripedTableCell>
                  {getCommServiceStatusText(selectedItem.status)}
                </StripedTableCell>
              </StripedTableRow>
              {selectedItem.status === -100 && (
                <StripedTableRow>
                  <StripedTableHeadCell>Rejected Reason</StripedTableHeadCell>
                  <StripedTableCell>
                    {selectedItem.rejectReason}
                  </StripedTableCell>
                </StripedTableRow>
              )}
              <StripedTableRow>
                <StripedTableHeadCell>Hours</StripedTableHeadCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Minutes</StripedTableHeadCell>

              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Document</StripedTableHeadCell>
                <StripedTableCell>
                  <Link component="button" onClick={onClickDownloadFile}>
                    {selectedItem.originalFilename}
                  </Link>
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Verifier Email</StripedTableHeadCell>
                <StripedTableCell>
                  {selectedItem.verifierEmail}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Verifier Status</StripedTableHeadCell>
                <StripedTableCell>
                  {selectedItem.verifierStatus === 0 && (
                    <Chip label="PENDING" color="primary" /> 
                  )}
                  {selectedItem.verifierStatus === -100 && (
                    <>
                      <Chip label="REJECTED" color="error" />
                      {" "}({selectedItem.verifierReason})
                    </>
                  )}
                  {selectedItem.verifierStatus === 100 && (
                    <>
                      <Chip label="APPROVED" color="success" />
                      {" "}({dayjs(selectedItem.dateVerified).format("MM/DD")})
                    </>
                  )}
                  
                </StripedTableCell>
              </StripedTableRow>
            </TableBody> */}
              </Table>
            </TableContainer>

            <br />
            <Button variant="contained" onClick={onSave}>
              Save Service Ops
            </Button>
          </Box>
        )}

        {_selectedTabIndex === 1 && (
          <Box sx={{ boxShadow: 1, p: 1, mt: 1 }}>
            <SubTitle text="Existing Entries" />
            <TableContainer component={Paper} sx={{ mt: 0 }}>
              <Table sx={{ width: "100%" }} size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Student</StripedTableCell>
                    <StripedTableCell>Type</StripedTableCell>
                    <StripedTableCell align="center">Hour</StripedTableCell>
                    <StripedTableCell align="center">Minute</StripedTableCell>
                    <StripedTableCell align="center">Actions</StripedTableCell>
                  </StripedTableRow>
                </TableHead>
                <TableBody>
                  <TableRowNoResults data={existingOps} />
                  {existingOps.map((op) => (
                    <StripedTableRow>
                      <StripedTableCell>
                        {op.last_name}, {op.first_name}
                      </StripedTableCell>
                      <StripedTableCell>{op.typeName}</StripedTableCell>
                      <StripedTableCell align="center">
                        {op.hourNum}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        {op.minuteNum}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        <IconButton
                          edge="end"
                          aria-label="remove op"
                          title="remove op"
                          onClick={() => onClickRemove(op)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={_csLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommServiceBulkDialog;
